// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608181730/js/" + chunkId + "." + {"44":"37c23360","225":"6698c359","481":"df9ed9ae","486":"3919646f","770":"29e19866"}[chunkId] + ".0.43536582761950127.chunk.js";
};